
import React, { useEffect, useState } from "react";
import { APIGET } from '../../services/APIServices';
import Loading from '../../images/Table/Loading.gif';
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from "react-router-dom";
import ThemeControls from "../AllThemesControl";
import FormScopeDefiner from "./FormScopeDefiner";
import { useLocation, useParams } from 'react-router-dom';
import { Typography } from '@material-ui/core';
import { IoIosRefresh } from "react-icons/io";
import { Navigate } from "react-router-dom";

function EditForm(props) {
  const { id } = useParams();
  const location = useLocation();
  const receivedData = location?.state;
  const currentUrl = location.pathname;
  //console.log(location)
  const {
    contextJson,
    formFieldsJson,
    close,
    index,
    dataArr,
    apiContextObj
  } = receivedData || {}; // Destructuring with default values for null receivedData
  const { useStyles } = ThemeControls;
  const classes = useStyles();
  const navigate = useNavigate();
  const [editData, setEditData] = useState([]);
  const contextObjective = "update";
  const contextIndex = index;
  const [contextDataArr, setContextDataArr] = useState(dataArr);
  const [editFOpen, setEditFOpen] = useState(false);
  const [error, setError] = useState(null); // Track errors
  
  function fetchEditData(apiContext, id) {
    if (typeof apiContext === 'string') {
      fetchData(apiContext, "/all", id);
    } else if (Array.isArray(apiContext)) {
      const promises = apiContext.map((item) => {
        if (item.apiContext && item.type && item.id) {
          return fetchData(item.apiContext, item.type, id, item.id);
        }
        return Promise.resolve(null);
      });

      Promise.all(promises)
        .then(() => {
          setEditFOpen(true);
        })
        .catch((error) => {
          setError(error); // Set error state
        });
    } else {
       
    }
  }

  async function fetchData(apiContextVar, type, id, arryId) {
    try {
      const response = await APIGET(`${apiContextVar}${type}${id}`);
      if (response.data) {
        ////console.log(response)
        const apiResponseData = response.data;
        // response[apiContextVar] = apiResponseData;
        setEditData((prevData) => [...prevData, apiResponseData]);
        // setEditData(apiResponseData);
      }else{
        setEditData([])
        alert("Error fetching data")
        setError("Error fetching data")
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }


  useEffect(() => {
    const removeLastSegmentFromUrl = (url) => {
      let segments = url.split('/');
      segments.pop();
      return segments.join('/');
    };

    if (receivedData === null) {
      const routeUrl = removeLastSegmentFromUrl(currentUrl) 
      navigate(routeUrl);
      // return <Navigate  to={routeUrl} />;
    }else{
      fetchEditData(apiContextObj.editFlow.apiContextGet, id);
    }
  }, [id, receivedData]);

  useEffect(() => {
    if (editData && editData.length !== undefined && editData.length !== 0) {
      if (Array.isArray(editData)) {
        // This code block will execute if editData is an array
        editData.map((formData,index)=>{
          //console.log(formData)
          if (Array.isArray(formData)&&editData.length !== 0) {
            Object.keys(formFieldsJson).forEach((key) => {
              if (formFieldsJson[key].fields) {
                mapFields(formFieldsJson[key].fields, formData[0], apiContextObj.id);
              }
            });
          }
           if (typeof formData === 'object'){
            Object.keys(formFieldsJson).forEach((key) => {
              if (key !== "xioFEConfig" && key !== "Parameter_Billing" && formFieldsJson[key].fields) {
                mapFields(formFieldsJson[key].fields, formData, apiContextObj.id);
              // } else if(formFieldsJson[key].fields){
              //   mapFields(formFieldsJson[key].fields, formData, apiContextObj.id);
              }
            });
          }
        })
      } else if (typeof editData === 'object') {
        // This code block will execute if editData is an object
        Object.keys(formFieldsJson).forEach((key) => {
          if (key !== "xioFEConfig" && key !== "Parameter_Billing" && formFieldsJson[key].fields) {
            mapFields(formFieldsJson[key].fields, editData, apiContextObj.id);
          } else if(formFieldsJson[key].fields){
            mapFields(formFieldsJson[key].fields, editData, apiContextObj.id);
          }
        });
      }
    }
  }, [editData]);  

//console.log(editData)

  // function mapFields(fields, data, idKey) {
  //       fields.forEach((field) => {
  //         field.field_value = data[field.field_id];
  //         field.id = data[idKey] || field.id; // Use field.id if data[idKey] is undefined
  //       });
  //     }

  // function mapFields(fields, data, idKey) {
  //   fields.forEach((field) => {
  //     ////console.log(field)
  //     if (field.field_id === 'responseEmail' && data['responseEmail']) {
       
  //       const emails = data[field.field_id].data.map((emailObj) => emailObj.email);
        
  //       field.field_value = emails.join(', ');
  //     } else if (field.field_id === 'routebreakout' && data['responseQuality']) {
  //       const qualityData = data['responseQuality'].data;
  //       const breakout = qualityData.map((item) => item.routebreakout);

  //       field.field_value = breakout.join(', ');
  //     } else if (data['responseQuality']) {
  //       const qualityData = data['responseQuality'].data;
        
  //       field.field_value = qualityData[0][field.field_id];
  //     } else{
  //       alert('hello');
       
  //     }
  //     field.field_value = data[field.field_id];
  //     field.id = data[idKey] || field.id;
  //   });
  // }
  function toCamelCase(input) {
    return input.charAt(0).toUpperCase() + input.slice(1);
  }
  function mapFields(fields, data, idKey) {
    fields.forEach((field) => {
      if(field.field_type==="nestedRender"){
        if (data && data.hasOwnProperty(idKey)) {
          field.id = data[idKey];
        }
       let felidId = toCamelCase(field.field_id)
       Object.keys(field.field_context).forEach((key, index) => {
        if (key !== "xioFEConfig") {
          field.field_context[key].fields.map((field) => {
            //console.log(field)
            if(field.field_type==="multilineText"){
              let temp= data["response"+felidId]?.data?.map((item) =>item[field.field_id]);
                // //console.log(temp)
                field.field_value = temp.join(', ')
                data["response"+felidId]?.data?.forEach((item) => {
                  field.id = item[idKey];
                });
            }else if(field.field_type==="multiSelectCheckBox"){
              let temp= data["response"+felidId]?.data?.map((item) =>item[field.field_id]);
              // //console.log(temp)
              field.field_value=temp
              data["response"+felidId]?.data?.forEach((item) => {
                field.id = item[idKey];
              });
            }else{
              
              data["response"+felidId]?.data?.forEach((item) => {
                // //console.log(item)
                field.field_value = item[field.field_id]
                field.id = item[idKey];
              });
            }
            // field.field_value = data[field.field_id];
          });
        }
      });
       
      }else if(field.field_type==="nestedAddRowRender"){
        const key =field.field_id;
        if(data && key){
          //console.log(data[key])
          field.field_value=data[key];
        }
        if (data && data.hasOwnProperty(idKey)) {
          field.id = data[idKey];
        }
      }else if(field.field_type==="subForm"){
        Object.keys(field.fields).forEach((key) => {
          if (key !== "xioFEConfig") {
            field.fields[key].fields.map((subFormFields)=>{
              //console.log(subFormFields)
              if(subFormFields.field_id==='organizationid'&& data && data.hasOwnProperty(idKey)){
                subFormFields.field_value = data[idKey];
                //console.log(data[idKey])
                //console.log(subFormFields.field_id)
              }
            })
          }})
          if (data && data.hasOwnProperty(idKey)) {
            field.id = data[idKey];
          }
      } else{
        if (data && field && field.field_id && data.hasOwnProperty(field.field_id)) {
          field.field_value = data[field.field_id];
        }else{
          if (data && field && field.temp_id && data.hasOwnProperty(field.temp_id)) {
            field.field_value = data[field.temp_id];
          }
        }
        if (data && data.hasOwnProperty(idKey)) {
          field.id = data[idKey];
        }
      }
    });
  }
     
  return (
    <>
      {/* <div className={classes.close}>
        <CloseIcon onClick={close} />
        <h4>Edit {contextHeading}</h4>
      </div> */}
      <div className={classes.main}>
        <div className={classes.formAline}>
          <Typography variant="h6" className={classes.marginChange}>
            {/* {contextHeading} */}
          </Typography>
          {error ? ( // Display an error message if there's an error
            <div className={classes.errorCard}>
              Error: {error} <IoIosRefresh onClick={()=>fetchEditData(apiContextObj.editFlow.apiContextGet, id)}/>
            </div>
          ) : editData.length>0 ? (
            // <div className={classes.pt}>
            <FormScopeDefiner value={{ editData,setEditData, close, contextJson, apiContextObj,   contextObjective, contextIndex, contextDataArr }}></FormScopeDefiner>
            // </div>
          ) : (
            <div className={classes.loader}>
              <img src={Loading} alt="Loading..." />
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default EditForm;

